import { http, type ApiEnvelope } from "./http";

export interface AuthProfile {
  id: string;
  username: string;
  displayName: string;
  roles: string[];
  permissions: string[];
  projects: Array<{ projectId: string; projectRole: string }>;
}
export interface LoginResult {
  expiresAt: string;
  profile: AuthProfile;
}

export interface DingTalkAuthConfig {
  enabled: boolean;
  corpId: string;
  clientId: string;
  insideLogin: boolean;
  jitProvisioning: boolean;
}

export interface LoginChallenge {
  challengeId: string;
  expiresAt: string;
  captchaImage: string;
  captchaLength: number;
  crypto: {
    version: 1;
    kid: string;
    alg: "RSA-OAEP-256";
    enc: "A256GCM";
    publicKeyJwk: JsonWebKey;
  };
}

export interface LoginEnvelope {
  version: 1;
  kid: string;
  challengeId: string;
  wrappedKey: string;
  iv: string;
  ciphertext: string;
}

export const getLoginChallenge = () =>
  http.get<never, ApiEnvelope<LoginChallenge>>("/auth/login/challenge");
export const login = (payload: LoginEnvelope) =>
  http.post<never, ApiEnvelope<LoginResult>>("/auth/login", payload);
export const getProfile = () =>
  http.get<never, ApiEnvelope<AuthProfile>>("/auth/me");
export const refreshSession = () =>
  http.post<never, ApiEnvelope<LoginResult>>("/auth/refresh", {});
export const logout = () => http.post("/auth/logout", {});
export const getDingTalkAuthConfig = () =>
  http.get<never, ApiEnvelope<DingTalkAuthConfig>>("/auth/dingtalk/config");
export const loginWithDingTalkCode = (authCode: string) =>
  http.post<never, ApiEnvelope<LoginResult>>("/auth/dingtalk/inside", {
    authCode,
  });
